<div class="mobile-panel-list d-lg-none" [ngClass]="rootClass" *ngIf="items?.length">
    <div class="nav flex-column nav-pills" [ngClass]="listClass">
        <h5 [class]="sectionHeaderClass" *ngIf="sectionHeader" [innerHTML]="sectionHeader"></h5>
        <button class="mobile-panel-list-button nav-link" [ngClass]="buttonClass" type="button" aria-haspopup="dialog" (click)="openItem(item)" *ngFor="let item of items">
            {{ item.title }}
        </button>
    </div>
</div>

<ng-template #mobilePanelModal>
    <div [ngClass]="modalClass" *ngIf="activeTemplateItem as item">
        <h3 class="visually-hidden" [id]="titleId">{{ activeTitle }}</h3>

        <div class="mobile-panel-list-modal-content" [ngClass]="contentClass">
            <ng-container *ngIf="activeTemplate as template">
                <ng-container *ngTemplateOutlet="template; context: { $implicit: item, item: item, isMobile: true }"></ng-container>
            </ng-container>

            <div class="nav flex-column nav-pills w-100 mobile-panel-list-child-nav" *ngIf="activeChildren.length">
                <button class="mobile-panel-list-button nav-link" type="button" (click)="openChild(child)" *ngFor="let child of activeChildren">
                    {{ child.title }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
